import { FC, ReactNode } from 'react';
import DefaultLayout from '@components/layout/DefaultLayout';
import BankingHeader from '@components/banking/BankingHeader';
import BankingTabs from '@components/banking/BankingTabs';

interface DefaultLayoutProps {
  children: ReactNode;
  noTabs?: boolean;
}

const BankingLayout: FC<DefaultLayoutProps> = ({ children, noTabs }) => {
  return (
    <DefaultLayout>
      <BankingHeader />
      {noTabs ? <div className="mt-8" /> : <BankingTabs />}
      {children}
    </DefaultLayout>
  );
};

export default BankingLayout;
